<template>
  <el-main>
    <el-row>
      <h2>成绩查询</h2>
    </el-row>      

      <el-table
          ref="singleTable"
          :row-style="{height:'20px'}"
          :cell-style="{padding:'0px'}"
          :data="xmList"
          border
          highlight-current-row
          @current-change="handleCurrentChange"
          style="width: 100%">

          <el-table-column
        
            label="项目"
            width="300">
           <template slot-scope="scope">
            <i class="el-icon-time"></i>
            <span style="margin-left: 10px">{{ scope.row.xmname }}</span>
          </template>

          </el-table-column>        


          <el-table-column label="全体报表">
            <template slot-scope="scope">
              <el-button
                size="mini"
                @click="handleXm(scope.$index, scope.row)">查看</el-button>
            
            </template>
         </el-table-column>

        <el-table-column label="校级报表">
              <template slot-scope="scope">
                <el-button
                  size="mini"
                  @click="handleSchool(scope.$index, scope.row)">查看</el-button>
              
              </template>
          </el-table-column>
        </el-table>

      <el-table
          ref="schoolTable"
          :row-style="{height:'20px'}"
          :cell-style="{padding:'0px'}"
          v-show="!status"

          :data="schoolList"
          border
          highlight-current-row
          @current-change="handleCurrentChange"
          style="width: 100%">
           <el-table-column :label="title">
              <el-table-column
            
                label="学校"
                width="300">
              <template slot-scope="scope">
                <i class="el-icon-time"></i>
                <span style="margin-left: 10px">{{ scope.row.sc }}</span>
              </template>

              </el-table-column>        


              <el-table-column label="学校报表">
                <template slot-scope="scope">
                  <el-button
                    size="mini"
                    @click="handleEdit(scope.$index, scope.row)">查看</el-button>
                
                </template>
            </el-table-column>

            <el-table-column label="班级报表">
                  <template slot-scope="scope">
                    <el-button
                      size="mini"
                      @click="handleSchool(scope.$index, scope.row)">查看</el-button>
                  
                  </template>
              </el-table-column>
           </el-table-column>
        </el-table>

      <el-collapse v-show="status" v-model="activeName" accordion>
              <el-collapse-item :title="title">
                
                  <div>与现实生活一致：与现实生活的流程、逻辑保持一致，遵循用户习惯的语言和概念；</div>
                  <div>{{ schoolList }}</div>
              </el-collapse-item>
     
      </el-collapse>


      <el-button @click="handleClick"   type="primary" icon="el-icon-edit">项目列表</el-button>
     	<el-button @click="handleClickImg"   type="primary" icon="el-icon-edit">获取图像</el-button>
  
      <div class="yjimage">
            <el-image
            
             
              :src="img_src"
              :fit="fit">
                <div slot="placeholder" class="image-slot">
                  <i class="el-icon-picture-outline"></i>
                </div>
            </el-image>
      </div>

      <el-tabs v-model="editableTabsValue" type="card" >
          <el-tab-pane
            v-for="(item, index) in editableTabs"
            :key="item.name"
            :label="item.title"
            :name="item.name"
          >
            {{item.content}}
          </el-tab-pane>
      </el-tabs>
 

  </el-main>
  

</template>
<script>
import axios from 'axios'
import qs from 'qs'
export default {
  data() {
    return {
      		img_src:'',
          fit:'contain',
          xmList: [],
          currentRow: null,
          status:false,
          title:'hello world',
          schoolList:[],
          selXmName:'',
          selSchool:'',
          selClass:'',
          editableTabs: [
            {
                title: 'Tab 1',
                name: '1',
                content: 'Tab 1 content'
            }, 
            {
                  title: 'Tab 2',
                  name: '2',
                  content: 'Tab 2 content'
            }
            ],
         };
  },
  methods: {
     
     getSchoolList () {
          let postdata = {"xm":this.selXmName};
          axios.post('/score?op=exameSchool',qs.stringify({"xm":this.selXmName})).then((res)=>{
                  console.log(res)
                  this.schoolList=res.data;
                  
              }).catch((res)=>{
                  console.log(response)
              })
        },

     
     handleXm(index, row) {
        this.selXmName=this.xmList[index]["xmname"];
        console.log(index, row);
        console.log(this.xmList[index]["xmname"]);
        this.title="全体报表---------"+this.xmList[index]["xmname"];
        this.status=true;

        axios.post('/score?op=exameKemu',qs.stringify({"xm":this.selXmName})).then((res)=>{
              console.log(res)
              this.editableTabs=res.data;
              
          }).catch((res)=>{
              console.log(response)
          })


       
      },

     handleSchool(index, row) {
       
        this.selXmName=this.xmList[index]["xmname"];
        this.title="校级报表---------"+this.xmList[index]["xmname"];
        this.getSchoolList();
         this.status=false;
  
      },
    
     handleClick () {
     axios.get('/score?op=exameList').then((res)=>{
                console.log(res)
                this.xmList=res.data;
                this.status=true;
            }).catch((res)=>{
                console.log(response)
            })
        },




       handleClickImg () {
             axios.get('/score?op=oneTizumg', {
                responseType: 'blob' //指定返回数据的格式为blob
            }).then((response)=>{
                console.log(response)
                 var urlCreator = window.URL || window.webkitURL;
								var imageUrl = urlCreator.createObjectURL( response.data );
								this.img_src = imageUrl; 
            }).catch((response)=>{
                console.log(response)
               
            })
       },

  },
}
</script>